import styled from "styled-components";

export const ChatRoomStyle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;

  .chat-area {
    height: 610px;
    background: white;
    border-radius: 10px;
    width: 600px;
    margin: 10px;
    flex-direction: column;
    padding: 5px 15px;
    -webkit-box-shadow: 7px 5px 15px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 13px 5px 15px 6px rgba(0, 0, 0, 0.2);
  }

  .header-area {
    align-items: center;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #e5e4e4;
    margin: 0px 5px;
  }

  .right-side {
    align-items: center;
    display: flex;
  }

  .left-side {
    p {
      color: #7e8b7e;
      font-size: 20px;
      margin: 0;
    }
  }

  .sign-out {
    button {
      border: none;
      background: none;
      color: #ffc107;
      font-style: italic;
      padding: 5px;
      border: 1px solid;
      border-radius: 5px;
    }

    button:hover {
      background-color: red;
      color: white;
      transition: background 0.3s linear;
    }
  }

  //mesages-area

  .submit-area {
    position: relative;
    display: flex;
    align-items: flex-end;

    input {
      margin-top: 10px;
      height: 26px;
      width: 84%;
      border: 1px solid #e5e4e4;
      border-radius: 5px;
    }

    .send-button {
      width: 50px;
      height: 30px;
      background: white;
      border: 1px solid #80808033;
      border-radius: 5px;
      background: #0080004d;
      margin-left: 3px;
      color: grey;
      transition: background 0.3s linear;
    }

    .send-button:hover {
      background: #e180148a;
    }
  }

  .image {
    margin-right: 10px;
    border-radius: 40px;
    width: 40px;
    margin-bottom: 5px;
  }

  main {
    padding: 10px 0px;
    background-image: url(/background.jpg);
    height: 50vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .message-item {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    flex-direction: initial;
    overflow-wrap: break-word;
    margin: 0px 5px;
  }

  .message-item-user {
    flex-direction: row-reverse;

    .message-text {
      background: #fbfbf8db;
      align-self: flex-end;
    }
  }

  .message-img {
    position: absolute;
    width: 35px;
    border-radius: 20px;
    bottom: 0px;
  }

  .user-name {
    font-size: 12px;
    color: #97256ca3;
    font-weight: bold;
    margin: 5px 0px;
  }

  .nav-link-user {
    text-decoration: none;
  }

  .message-text {
    position: relative;
    font-size: 15px;
    margin: 4px 45px 0px 40px;
    color: #2c2727d6;
    max-width: 250px;
    padding: 5px 20px;
    background: #c0d7c1ed;
    border-radius: 10px;
    border: 1px solid #6662621a;
  }

  .heart-img {
    position: absolute;
    bottom: 5px;
    right: 10px;
    width: 15px;
    opacity: 65%;
  }

  .emoji-button {
    background: #ffff0063;
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #d5cece;
    margin-left: 5px;
    transition: background 0.3s linear;
  }

  .emoji-button:hover {
    background: #e180148a;
  }

  .picker-style {
    position: absolute;
    right: 0;
    bottom: 40px;
  }

  .user-img {
    max-width: 200px;
  }

  .uploadFile-styles {
    max-width: 90px;
  }

  input[type="file"] + label {
    background: #d7d0d0;
    border: 1px solid #bbafaf;
    border-radius: 5px;
    font-size: 15px;
    color: gray;
    padding: 5px 2px;
    margin-left: 3px;
    text-align: center;
    transition: background 0.3s linear;
  }

  input[type="file"] + label:hover {
    background: #e180148a;
  }

  // users

  .users-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 200px;
    background: white;
    border-radius: 10px;
    height: 620px;
    margin: 10px -10px;
    box-shadow: -4px 4px 18px -6px rgb(0 0 0 / 20%);
  }

  .users-title {
    font-size: 20px;
    margin-bottom: 3px;
    color: #7e8b7e;
    align-text: center;
    text-align: center;
    padding: 14px;
    border-bottom: 1px solid #e7e4e4;
  }

  .users-link {
    text-decoration: none;
  }

  .active {
    background: #b2d9b2;
  }

  .users-item {
    width: 94%;
    height: 50px;
    border-radius: 5px;
    display: flex;
    padding: 10px 5px;
  }

  .users-img {
    border-radius: 40px;
    width: 50px;
    height: 50px;
    margin-bottom: 5px;
    display: block;
  }

  .users-name {
    font-size: 14px;
    padding: -12px 0;
    color: #7e8b7e;
    margin: 5px 5px;
  }

  .typing-users {
    display: flex;
    position: absolute;
    left: 0;
    bottom: -15px;
    font-size: 11px;
    color: gray;
  }

  .change-message-input {
    background: none;
  }

  .main-chat {
    position: absolute;
    bottom: 0;
    left: 30px;
    font-size: 15px;
    font-weight: 700;
    color: #4caf50e6;
    padding: 0px;
  }

  // sub-menu

  .sub-menu-container {
    width: 100px;
    border: 1px solid #80808047;
    background: white;
    border-radius: 10px;
    z-index: 100;
  }

  .sub-menu-item {
    font-size: 15px;
    padding: 5px;
    text-align: center;
    color: gray;
  }

  .sub-menu-item: hover {
    background: #eeeed0ed;
  }
`;
